import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-gray-50 p-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900">
          rhea
        </h1>
        <p className="mt-2 text-lg text-gray-500">v0.0.0-dev</p>
        <p className="mt-6 text-sm text-gray-400">
          Hello, Ayushi. The scaffold is ready.
        </p>
      </div>
    </main>
  );
}
